/*
 * tnxi-bundle.js — configurator for sections/tnxi-bundle.liquid.
 * Lets a shopper pick avionics (Touch/No-Touch) + the panel's Color/Yoke/
 * Throttle variant, shows a live discounted bundle price, keeps everything in
 * sync with stock (a component that can't fulfill the required quantity is
 * disabled), and on Add adds the panel variant + G1000(s) + audio + any optional
 * add-on as separate cart line items tagged with a shared bundle id.
 *
 * Avionics are optional: a panel-only page runs the same configurator with no
 * avionics product set, so every avionics check tolerates an empty list.
 */
(function () {
  'use strict';

  function money(cents, format) {
    if (cents == null || isNaN(cents)) return '';
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cent = parts[1] ? decimal + parts[1] : '';
      return dollars + cent;
    }
    var re = /\{\{\s*(\w+)\s*\}\}/;
    var value = '';
    var token = (format.match(re) || [])[1];
    switch (token) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'"); break;
      default: value = withDelimiters(cents, 2);
    }
    var out = format.replace(re, value);
    return out.replace(/([.,])00(?=\D*$)/, ''); // drop trailing .00 for whole amounts
  }

  // Can this component satisfy the required quantity given its inventory?
  function canFulfill(item, qty) {
    if (!item || item.id == null) return false;
    if (!item.inv || !item.inv.managed) return true; // inventory not tracked
    if (item.inv.policy === 'continue') return true; // overselling allowed
    return (item.inv.qty || 0) >= qty;
  }

  function arraysEqual(a, b) {
    if (!a || !b || a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
    return true;
  }

  function initSection(section) {
    var configEl = document.querySelector('script[data-bundle-config="' + section.id.replace('tnxi-bundle-', '') + '"]')
      || section.parentNode.querySelector('script[data-bundle-config]');
    if (!configEl) return;
    var cfg;
    try { cfg = JSON.parse(configEl.textContent); } catch (e) { return; }

    var priceEl = section.querySelector('[data-bundle-price]');
    var stockEl = section.querySelector('[data-bundle-stock]');
    var addBtn = section.querySelector('[data-bundle-add]');
    var summaryEl = section.querySelector('[data-bundle-summary]');
    function sumLine(name, amount, cls) {
      return '<div class="tnxi-bundle__sum-line' + (cls ? ' ' + cls : '') + '">' +
        '<span>' + name + '</span><span>' + amount + '</span></div>';
    }
    var avionicsBtns = Array.prototype.slice.call(section.querySelectorAll('[data-avionics-id]'));
    var addonBtns = Array.prototype.slice.call(section.querySelectorAll('[data-addon-on]'));
    var panelGroups = Array.prototype.slice.call(section.querySelectorAll('[data-panel-group]'));

    var optionCount = panelGroups.length;
    var selectedValues = new Array(optionCount);
    var selectedAvionicsId = null;
    var hasAvionics = !!(cfg.avionics && cfg.avionics.length);
    var addon = cfg.addon && cfg.addon.id != null ? cfg.addon : null;
    var addonQty = cfg.addonQty || 1;
    // Never default an add-on on when it couldn't be fulfilled anyway.
    var addonOn = !!(addon && cfg.addonDefault && canFulfill(addon, addonQty));

    // Media thumbnails
    var mainImg = section.querySelector('.tnxi-bundle__main-image');
    section.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (mainImg) {
          mainImg.removeAttribute('srcset'); // srcset would otherwise override src
          mainImg.src = t.getAttribute('data-thumb');
        }
        section.querySelectorAll('.tnxi-bundle__thumb').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    // Click-to-zoom lightbox for the main image (desktop + mobile).
    if (mainImg) {
      var lb = document.createElement('div');
      lb.className = 'tnxi-bundle__lightbox';
      lb.innerHTML = '<button type="button" class="tnxi-bundle__lightbox-close" aria-label="Close">×</button><img alt="">';
      document.body.appendChild(lb);
      var lbImg = lb.querySelector('img');
      var hiRes = function (src) { return (src || '').replace(/([?&]width=)\d+/, '$12048'); };
      var openZoom = function () {
        lbImg.src = hiRes(mainImg.currentSrc || mainImg.src);
        lb.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      };
      var closeZoom = function () {
        lb.classList.remove('is-open');
        document.body.style.overflow = '';
      };
      mainImg.addEventListener('click', openZoom);
      lb.addEventListener('click', closeZoom);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeZoom(); });
    }

    function avionicsById(id) {
      return cfg.avionics.filter(function (v) { return v.id === id; })[0] || null;
    }

    // Find the panel variant matching the currently selected option values.
    function matchedPanel(values) {
      for (var i = 0; i < cfg.panelVariants.length; i++) {
        if (arraysEqual(cfg.panelVariants[i].options, values)) return cfg.panelVariants[i];
      }
      return null;
    }

    // Default selections: first avionics that can be fulfilled, first available
    // value of each panel option.
    (function setDefaults() {
      var av = cfg.avionics.filter(function (v) { return canFulfill(v, cfg.avionicsQty); })[0] || cfg.avionics[0];
      selectedAvionicsId = av ? av.id : null;
      panelGroups.forEach(function (group) {
        var gi = parseInt(group.getAttribute('data-panel-group'), 10);
        var opts = group.querySelectorAll('[data-value]');
        selectedValues[gi] = opts.length ? opts[0].getAttribute('data-value') : null;
      });
      // Prefer a starting combo that actually resolves to a fulfillable variant.
      var firstOk = cfg.panelVariants.filter(function (v) { return canFulfill(v, 1); })[0];
      if (firstOk) selectedValues = firstOk.options.slice();
    })();

    function render() {
      var panel = matchedPanel(selectedValues);
      var av = hasAvionics ? avionicsById(selectedAvionicsId) : null;
      var audio = cfg.audio && cfg.audio.id != null ? cfg.audio : null;

      // ---- availability ----
      var panelOk = canFulfill(panel, 1);
      var avOk = hasAvionics ? canFulfill(av, cfg.avionicsQty) : true;
      var audioOk = cfg.audioQty > 0 ? (audio ? canFulfill(audio, cfg.audioQty) : false) : true;
      var addonOk = addonOn ? canFulfill(addon, addonQty) : true;
      var allOk = !!panel && panelOk && avOk && audioOk && addonOk;

      // ---- price ----
      if (panel && (av || !hasAvionics)) {
        var total = panel.price
          + (av ? cfg.avionicsQty * av.price : 0)
          + (audio ? cfg.audioQty * audio.price : 0)
          + (addonOn && addon ? addonQty * addon.price : 0);
        var flat = (cfg.discountAmount || 0) * 100; // whole dollars -> cents
        var pct = cfg.discountPercent || 0;
        // A second saving (e.g. a pre-order promo) itemised on its own summary line.
        // The native checkout discount is still one combined amount.
        var extra = (cfg.preorderDiscount || 0) * 100;
        // Flat amount wins over % (matches a flat native discount).
        var panelSaved = flat > 0 ? Math.min(flat, total) : Math.round(total * pct / 100);
        var extraSaved = Math.max(0, Math.min(extra, total - panelSaved));
        var saved = panelSaved + extraSaved;
        var discounted = total - saved;
        var panelBadge = (cfg.discountBadge && cfg.discountBadge.trim())
          ? cfg.discountBadge
          : (flat > 0 ? money(flat, cfg.moneyFormat) + ' off panel' : pct + '% Bundle Discount');
        // With a second saving the pill shows the combined total, so it matches the cart.
        var badge = extraSaved > 0 ? money(saved, cfg.moneyFormat) + ' off' : panelBadge;
        var html = '';
        if (saved > 0) {
          html += '<span class="tnxi-bundle__now">' + money(discounted, cfg.moneyFormat) + '</span>';
          html += '<s class="tnxi-bundle__was">' + money(total, cfg.moneyFormat) + '</s>';
          html += '<span class="tnxi-bundle__pill">' + badge + '</span>';
        } else {
          html += '<span class="tnxi-bundle__now">' + money(total, cfg.moneyFormat) + '</span>';
        }
        priceEl.innerHTML = html;

        if (summaryEl) {
          var s = '';
          if (av) {
            s += sumLine(cfg.avionicsQty + '× ' + cfg.avionicsName + ' — ' + av.title, money(cfg.avionicsQty * av.price, cfg.moneyFormat));
          }
          if (audio && cfg.audioQty > 0) {
            s += sumLine(cfg.audioQty + '× ' + (audio.title || 'Audio panel'), money(cfg.audioQty * audio.price, cfg.moneyFormat));
          }
          s += sumLine(cfg.panelTitle, money(panel.price, cfg.moneyFormat));
          if (addonOn && addon) {
            s += sumLine(addonQty + '× ' + (addon.title || 'Add-on'), money(addonQty * addon.price, cfg.moneyFormat));
          }
          if (panelSaved > 0) s += sumLine(panelBadge, '-' + money(panelSaved, cfg.moneyFormat), 'tnxi-bundle__sum-line--save');
          if (extraSaved > 0) {
            s += sumLine(cfg.preorderLabel || 'Pre-order discount', '-' + money(extraSaved, cfg.moneyFormat), 'tnxi-bundle__sum-line--save');
          }
          s += sumLine('Total', money(discounted, cfg.moneyFormat), 'tnxi-bundle__sum-line--total');
          summaryEl.innerHTML = s;
        }
      } else {
        priceEl.innerHTML = '<span class="tnxi-bundle__now">&mdash;</span>';
        if (summaryEl) summaryEl.innerHTML = '';
      }

      // ---- avionics button states ----
      avionicsBtns.forEach(function (btn) {
        var id = parseInt(btn.getAttribute('data-avionics-id'), 10);
        var v = avionicsById(id);
        var ok = canFulfill(v, cfg.avionicsQty);
        btn.classList.toggle('is-active', id === selectedAvionicsId);
        btn.classList.toggle('is-unavailable', !ok);
        btn.disabled = !ok;
      });

      // ---- add-on button states ----
      addonBtns.forEach(function (btn) {
        var on = btn.getAttribute('data-addon-on') === 'true';
        var ok = on ? canFulfill(addon, addonQty) : true;
        btn.classList.toggle('is-active', on === addonOn);
        btn.classList.toggle('is-unavailable', !ok);
        btn.disabled = !ok;
      });

      // ---- panel option button states (disable values that can't resolve to a
      // fulfillable variant given the other current selections) ----
      panelGroups.forEach(function (group) {
        var gi = parseInt(group.getAttribute('data-panel-group'), 10);
        group.querySelectorAll('[data-value]').forEach(function (btn) {
          var val = btn.getAttribute('data-value');
          var trial = selectedValues.slice();
          trial[gi] = val;
          var v = matchedPanel(trial);
          var ok = canFulfill(v, 1);
          btn.classList.toggle('is-active', selectedValues[gi] === val);
          btn.classList.toggle('is-unavailable', !ok);
        });
      });

      // ---- stock message + add button ----
      addBtn.disabled = !allOk;
      if (!allOk) {
        var msg = 'Currently unavailable in this configuration.';
        if (panel && !avOk) msg = 'Selected avionics is out of stock (need ' + cfg.avionicsQty + ').';
        else if (panel && !audioOk) msg = 'Audio panel is out of stock.';
        else if (panel && !addonOk) msg = (addon && addon.title ? addon.title : 'The add-on') + ' is out of stock.';
        else if (!panel || !panelOk) msg = 'This panel option is out of stock.';
        stockEl.textContent = msg;
        stockEl.hidden = false;
      } else {
        stockEl.hidden = true;
      }
    }

    // ---- events ----
    avionicsBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        selectedAvionicsId = parseInt(btn.getAttribute('data-avionics-id'), 10);
        render();
      });
    });

    addonBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        addonOn = btn.getAttribute('data-addon-on') === 'true';
        render();
      });
    });

    panelGroups.forEach(function (group) {
      var gi = parseInt(group.getAttribute('data-panel-group'), 10);
      group.querySelectorAll('[data-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          selectedValues[gi] = btn.getAttribute('data-value');
          render();
        });
      });
    });

    addBtn.addEventListener('click', function () {
      var panel = matchedPanel(selectedValues);
      var av = hasAvionics ? avionicsById(selectedAvionicsId) : null;
      if (!panel || (hasAvionics && !av)) return;
      var bundleId = 'fvb-' + Date.now() + '-' + Math.floor(Math.random() * 1e6);
      // The whole build ships together, so every line carries the pre-order window.
      function props() {
        var p = { _bundle: bundleId };
        if (cfg.shipsNote) p[cfg.shipsLabel || 'Ships'] = cfg.shipsNote;
        return p;
      }
      var items = [{ id: panel.id, quantity: 1, properties: props() }];
      if (av) items.push({ id: av.id, quantity: cfg.avionicsQty, properties: props() });
      if (cfg.audio && cfg.audio.id != null && cfg.audioQty > 0) {
        items.push({ id: cfg.audio.id, quantity: cfg.audioQty, properties: props() });
      }
      if (addonOn && addon) {
        items.push({ id: addon.id, quantity: addonQty, properties: props() });
      }
      addBtn.classList.add('is-loading');
      addBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () {
          addBtn.classList.remove('is-loading');
          addBtn.disabled = false;
          stockEl.textContent = 'Sorry — could not add to cart. Please try again.';
          stockEl.hidden = false;
        });
    });

    render();
  }

  document.querySelectorAll('[data-tnxi-bundle]').forEach(initSection);
})();
